import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class CorpNewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        yearsConData: PropTypes.string,
    };

    constructor(props) {
        super(props);

        const { content } = this.props;

        this.state = {
            // 默认展示2019年的 大事记内容
            contentData: content.newList2020,
        };
    }

    componentDidMount() {
        this.createChannelInfo();
    }

    componentDidUpdate(prevProps) {
        if (this.props.yearsConData !== prevProps.yearsConData) {
            this.createChannelInfo();
        }
    }

    createChannelInfo = () => {
        const { content, yearsConData } = this.props;

        this.setState({
            contentData: content[yearsConData],
        });
    };

    render() {
        return (
            <div className={styles.recorLinks}>
                <ul className={styles.linksUl}>
                    {this.state.contentData.map((item, index) => {
                        return (
                            <li key={index}>
                                <a href={item.url}>{item.title}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default CorpNewsList;
